import { TableState, SeatState } from './PokerTable';

export function numActivePlayers(tableState: TableState) {
  return tableState.seats.filter(s => s.state !== SeatState.EMPTY).length;
}
